import React from 'react'
import {Title} from '../../ui-components'

const Card = ({
    textTitle = "Título",
    withSubtitle = "false", 
    textSubtitle = "subtitle" ,
    classNameBody = "py-24",
    elementBody = "",

}) => {

    const sendTitle = {
        TitleWindow: {children: `${textTitle}`},
        Subtitle: {children: `${textSubtitle}`}
    }

  return (
    <div className='m-7'>
      <div className='mainCard'>
        <div className='absolute top-14 left-20'>
         <Title subtitle={withSubtitle} overrides={sendTitle}/>
        </div>
        <div className={classNameBody}>
            {elementBody}
        </div>
      </div>
    </div>
  )
}

export default Card